'use client';

import type { CropHandle, RectSelection } from './types';

interface CropHandlesProps {
  box: RectSelection;
  onResizeStart: (handle: CropHandle, event: React.PointerEvent) => void;
}

export function CropHandles({ box, onResizeStart }: CropHandlesProps): React.JSX.Element {
  const handles: Array<{ id: CropHandle; style: React.CSSProperties; cursor: string }> = [
    { id: 'nw', style: { left: box.x - 5, top: box.y - 5 }, cursor: 'nwse-resize' },
    { id: 'n', style: { left: box.x + box.width / 2 - 5, top: box.y - 5 }, cursor: 'ns-resize' },
    {
      id: 'ne',
      style: { left: box.x + box.width - 5, top: box.y - 5 },
      cursor: 'nesw-resize',
    },
    {
      id: 'e',
      style: { left: box.x + box.width - 5, top: box.y + box.height / 2 - 5 },
      cursor: 'ew-resize',
    },
    {
      id: 'se',
      style: { left: box.x + box.width - 5, top: box.y + box.height - 5 },
      cursor: 'nwse-resize',
    },
    {
      id: 's',
      style: { left: box.x + box.width / 2 - 5, top: box.y + box.height - 5 },
      cursor: 'ns-resize',
    },
    {
      id: 'sw',
      style: { left: box.x - 5, top: box.y + box.height - 5 },
      cursor: 'nesw-resize',
    },
    {
      id: 'w',
      style: { left: box.x - 5, top: box.y + box.height / 2 - 5 },
      cursor: 'ew-resize',
    },
  ];

  return (
    <>
      {handles.map((handle) => (
        <button
          key={handle.id}
          type="button"
          aria-label={`Изменить размер (${handle.id})`}
          className="absolute z-10 h-[10px] w-[10px] rounded-[2px] border border-black/20 bg-white shadow-sm"
          style={{ ...handle.style, cursor: handle.cursor }}
          onPointerDown={(event) => onResizeStart(handle.id, event)}
        />
      ))}
    </>
  );
}
